import type React from "react";

// The V4 design's stroke icons (24px grid, 2px stroke), sized by the caller.
const Stroke = ({ size, children }: { size: number; children: React.ReactNode }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden
  >
    {children}
  </svg>
);

type IconProps = { size?: number };

export const CloseIcon = ({ size = 14 }: IconProps) => (
  <Stroke size={size}>
    <path d="M6 6l12 12M18 6 6 18" />
  </Stroke>
);

export const ZapIcon = ({ size = 13 }: IconProps) => (
  <Stroke size={size}>
    <path d="M13 2 4 14h7l-1 8 9-12h-7l1-8z" />
  </Stroke>
);

export const CaretRightIcon = ({ size = 10 }: IconProps) => (
  <svg width={size} height={size} viewBox="0 0 10 10" fill="currentColor" aria-hidden>
    <path d="M3 1.5v7L8 5z" />
  </svg>
);

export const ChevronDownIcon = ({ size = 15 }: IconProps) => (
  <Stroke size={size}>
    <path d="m6 9 6 6 6-6" />
  </Stroke>
);

export const ChevronUpIcon = ({ size = 15 }: IconProps) => (
  <Stroke size={size}>
    <path d="m6 15 6-6 6 6" />
  </Stroke>
);

export const TemplateIcon = ({ size = 14 }: IconProps) => (
  <Stroke size={size}>
    <rect x="4" y="3" width="16" height="18" rx="2" />
    <path d="M8 8h8M8 12h8M8 16h5" />
  </Stroke>
);

export const MicIcon = ({ size = 13 }: IconProps) => (
  <Stroke size={size}>
    <rect x="9" y="3" width="6" height="11" rx="3" />
    <path d="M5 11a7 7 0 0 0 14 0M12 18v3" />
  </Stroke>
);

export const SettingsIcon = ({ size = 13 }: IconProps) => (
  <Stroke size={size}>
    <circle cx="12" cy="12" r="3" />
    <path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1" />
  </Stroke>
);

export const ClockIcon = ({ size = 12 }: IconProps) => (
  <Stroke size={size}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </Stroke>
);
